import script from "./SingleProduct.vue?vue&type=script&lang=ts&setup=true"
export * from "./SingleProduct.vue?vue&type=script&lang=ts&setup=true"

import "./SingleProduct.vue?vue&type=style&index=0&id=07f90b89&lang=css"

const __exports__ = script;

export default __exports__